/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsPartnersListViewProps } from "../../../modules/hosports-partners-list/./hosports-partners-list";
//@ts-ignore
import SideBySideTextAndImage from "./../../../baseComponents/side-by-side-image-and-text/./side-by-side-image-and-text";
//@ts-ignore
import ScrollFadeIn from "./../../../baseComponents/scroll-fade/./scroll-fade";

class HosportsPartnersList extends React.Component<
  IHosportsPartnersListViewProps
> {
  render() {
    const { config } = this.props;
    console.log(config);
    let list: any = [];
    if (config) {
      if (config.partners) {
        for (let i = 0; i < config.partners.length; i++) {
          if (config.partners[i]) {
            console.log(config.partners[i]);
            let image: any = "";
            if (config.partners[i].image) {
              if (config.partners[i].image?.src) {
                image = config.partners[i].image?.src;
              }
            }
            list.push({
              title: config.partners[i].name,
              image: image,
              link: config.partners[i].webUrl,
              description: config.partners[i].description,
            });
          }
        }
      }
    }

    return (
      <div className="large-padding secondary-background">
        <div className="max-width-container">
          {list &&
            list.map((data: any, index: any) => {
              let direction = "left";
              if (index % 2 == 0) {
                direction = "right";
              }
              return (
                <div>
                  <SideBySideTextAndImage
                    title={data.title}
                    image={data.image}
                    buttonLink={data.link}
                    buttonText={data.link}
                    description={data.description}
                    direction={direction}
                    resizeMode="contain"
                  />
                  <div className="secondary-background" style={{ height: "1px", width:"100%" }}></div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

export default HosportsPartnersList;
